import goods_empty from '@/assets/good_empty.png';
import GoodsChunk from "../GoodsChunk";

export default {
  components: {GoodsChunk},
  data() {
	return {
	  watchList: [],
	  goods_empty,
	  observerKeys: []
	};
  },
  methods: {
	observerKey(key, callback) {
	  this.watchList.push(this.$watch(key, (now, old) => {
		if (isSame(now, old)) return;
		callback && callback(now, old);
	  }));
	},

	// region 预览逻辑

	// preview模式时,手动监视如下字段
	// 因为PC端通知时,会直接覆盖整个config,即便某个字段没有变化,也会导致chunkList变动,所以手动加监视
	observerWhenPreview() {
	  if (!this.preview) return;
	  this.observerKeys.forEach(key => {
		this.observerKey(key, this.createChunkList);
	  });
	},

	createChunkList() {
	  const list = (this.config.goods_from === 1 ? this.pageChunks : this.guidChunks);
	  // 预览时,最多只展示一页,避免过长
	  this.chunkList = this.preview ? list.slice(0, 1) : list;
	},

	// endregion
	getQuery: q => q
  },

  computed: {
	goodsStyle() {
	  const {page_margin, goods_margin} = this.config;
	  return {
		paddingLeft: page_margin + "px",
		paddingRight: page_margin + "px",
		marginLeft: -goods_margin / 2 + "px",
		marginRight: -goods_margin / 2 + "px",
	  };
	},
	// 数据来源是商户选定,按guids分组
	guidChunks() {
	  return this.$utils.chunkList(10)(this.config.guids).map(guids => ({
		key: guids.join(','),
		length: guids.length,
		query: this.getQuery({guids}),
		request: this.request,
	  }));
	},
	// 数据来源是自动分页获取,按分类总量分组
	pageChunks() {
	  const count = this.config.goods_number;
	  return this.$utils.chunk(10)(count).map((list, index) => ({
		key: 'groupon_page_' + index,
		length: this.config.goods_number,
		query: this.getQuery({pageIndex: index + 1, pageSize: Math.min(10, count)}),
		request: this.request,
	  }));
	},
  },

  beforeDestroyed() {
	this.watchList.forEach(fn => fn());
  }
};

function isSame(A, B) {
  if (typeof A !== typeof B) return false;
  if (typeof A === 'object') return JSON.stringify(A) === JSON.stringify(B);
  return A === B;
}
